import React from 'react';
import {resolveColor} from '../../../utils/colors';

const Users = ({width = '14px', height= '14px', color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.5 14.75V13.25C16.5 11.8521 15.5439 10.6775 14.25 10.3445M11.625 1.46807C12.7244 1.91311 13.5 2.99098 13.5 4.25C13.5 5.50902 12.7244 6.58689 11.625 7.03193M12.75 14.75C12.75 13.3522 12.75 12.6533 12.5216 12.1019C12.2172 11.3669 11.6331 10.7828 10.8981 10.4784C10.3467 10.25 9.64783 10.25 8.25 10.25H6C4.60218 10.25 3.90326 10.25 3.35195 10.4784C2.61687 10.7828 2.03284 11.3669 1.72836 12.1019C1.5 12.6533 1.5 13.3522 1.5 14.75M10.125 4.25C10.125 5.90685 8.78185 7.25 7.125 7.25C5.46815 7.25 4.125 5.90685 4.125 4.25C4.125 2.59315 5.46815 1.25 7.125 1.25C8.78185 1.25 10.125 2.59315 10.125 4.25Z"
                stroke={resolveColor(color) || '#6E6C6C'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};
export default Users;
